(function() {
  function fixVariantSelector() {
    if (typeof $ === 'undefined' || $('.single-option-selector__radio').length === 0) {
      setTimeout(fixVariantSelector, 100);
      return;
    }
    
    $('.single-option-selector__radio').off('change.variantFix').on('change.variantFix', function() {
      var selectedByIndex = {};
      $('.single-option-selector__radio:checked').each(function() {
        selectedByIndex[$(this).data('index')] = $(this).val();
      });
      
      var currentIndex = $(this).data('index');
      var displayNumber = currentIndex.replace('option', '');
      $('.js-swatch-display--' + displayNumber).text($(this).val());
      
      var selectedOptions = [];
      for (var i = 1; i <= 3; i++) {
        if (selectedByIndex['option' + i]) {
          selectedOptions.push(selectedByIndex['option' + i]);
        }
      }
      
      var $select = $('select[name="id"]');
      $select.find('option').each(function() {
        var sizePart = $(this).text().trim().split(' - ')[0].trim();
        if (sizePart === selectedOptions[0]) {
          $select.val($(this).val()).trigger('change');
          return false;
        }
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixVariantSelector);
  } else {
    fixVariantSelector();
  }
})();
